import { React } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';

import { METADATA } from '../../constants';
import Navbar from '../../components/HomeComponents/Navbar';
// import Footer from '../../components/HomeComponents/Footer';
import SectionOne from '../../components/HomeComponents/Musicmind/SectionOne';
import SectionTwo from '../../components/HomeComponents/Musicmind/SectionTwo';
import SectionThree from '../../components/HomeComponents/Musicmind/SectionThree';
import SectionFour from '../../components/HomeComponents/Sections/SectionFour';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  // sectionOne: {
  //   height: "500px",
  //   backgroundColor: "#e1eff6",
  // },
}));


export default function Musicmind() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Helmet>
        <meta name="description" content={METADATA.MUSICMIND.description} />
        <title>{METADATA.MUSICMIND.title}</title>
      </Helmet>
      <Navbar />
      <SectionOne />
      <SectionTwo />
      <SectionThree />
      <SectionFour />
    </div>
  )
}